// Feature flags. Flip these to toggle whole slices of the app on/off.
//
// SHOW_COSTING: master switch for ALL costing / financial UI — unit prices, line &
// order totals, PO/SO amounts, credit limits, payment terms and every ₹ field.
// Temporarily OFF so the app monitors production & inventory only. Set back to `true`
// to restore invoicing/costing everywhere (backend still stores the data untouched).
export const SHOW_COSTING = false;
